import React, { useEffect, useMemo, useState } from "react";

type VehicleImageFallbackProps = {
  fallbackSrc?: string;
  isActive?: boolean;
  index: number;
} & React.ImgHTMLAttributes<HTMLImageElement>;

export function VehicleImageFallback({
  src,
  alt,
  index,
  isActive,
  fallbackSrc = "https://webmotors.com.br/assets/img/webp/vehicle_no_photo.webp?t=1.0.1",
  ...props
}: VehicleImageFallbackProps) {
  const [error, setError] = useState(false);
  const [loadedSrc, setLoadedSrc] = useState<string | null>(null);

  const loading = index === 0 ? "eager" : "lazy";

  useEffect(() => {
    setError(false);
  }, []);

  const source = useMemo(() => {
    if (error) {
      return fallbackSrc;
    }

    if (loadedSrc) {
      return loadedSrc;
    }

    if (!src || !isActive) {
      return fallbackSrc;
    }

    return src;
  }, [error, fallbackSrc, src, isActive, loadedSrc]);

  const handleError = () => {
    setError(true);
  };

  const handleLoad = () => {
    if (isActive && src && !error) {
      setLoadedSrc(src);
    }
  };

  return (
    <img
      alt={alt}
      onError={handleError}
      onLoad={handleLoad}
      src={source}
      loading={loading}
      {...props}
    />
  );
}
